/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_No_ProfileInputs */

const en_ui_te_no_profile = /** @type {(inputs: Ui_Te_No_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set max & resting HR in your profile`)
};

const de_ui_te_no_profile = /** @type {(inputs: Ui_Te_No_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag Max- und Ruhepuls in deinem Profil ein`)
};

/**
* | output |
* | --- |
* | "Set max & resting HR in your profile" |
*
* @param {Ui_Te_No_ProfileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_no_profile = /** @type {((inputs?: Ui_Te_No_ProfileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_No_ProfileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_no_profile(inputs)
	return de_ui_te_no_profile(inputs)
});